export default {

    setCommandes (state, commandes) {
      state.all = commandes
      state.initialized = true
      state.page = 1
    },

    setCount(state, count) {
      state.count = count
    },

    setNextCommandes (state, commandes) {    
      state.all = [ ...state.all, ...commandes ]
      state.page++
    }
}